import {AfterViewInit, Component, DestroyRef, OnInit, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {InviteAFriendComponent} from 'src/app/dialogs/invite-a-friend/invite-a-friend.component';
import {EventsManager} from 'src/app/services/events.manager';
import {environment} from 'src/environments/environment';
import {Router, RouterLink} from '@angular/router';
import {GoogleAnalyticsService} from 'src/app/services/google-analytics.service';
import {NgClass, NgIf} from '@angular/common';
import {InfoModel} from 'src/app/models/info.model';

@Component({
  selector: 'app-subheader',
  templateUrl: './subheader.component.html',
  styleUrls: ['./subheader.component.scss'],
  imports: [NgClass, RouterLink, NgIf]
})

export class SubheaderComponent implements OnInit, AfterViewInit {
  private _googleAnalyticsService = inject(GoogleAnalyticsService);
  private _eventsManager = inject(EventsManager);
  private _router = inject(Router);
  private _destroyRef = inject(DestroyRef);

  public ngbModal = inject(NgbModal);

  public office: any = {};
  public environment: any = environment;
  public info: InfoModel = {telephoneNumber:'', address: '', weekDayHours:'', weekendHours:''};
  public hideLearnMore: boolean = false;
  public supportLink: string = '/support';
  public findADentistLink: string = '/find-a-dentist';
  public currentRoute: string = '';

  constructor() {
    this._router.events
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(() => {
        this.currentRoute = this._router.url;
      });
  }

  public ngOnInit(): void {
    this.office = this._eventsManager.getOfficeInfo();
    this._eventsManager.officeUpdate
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((result) => {
        this.office = result;
      });

    this._eventsManager.contactInfoUpdated
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(() => {
        this.info = this._eventsManager.contactInfo;
      });
  }

  public ngAfterViewInit(): void {
    this._eventsManager.hideHeader
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((hideHeader: boolean) => {
        this.hideLearnMore = hideHeader;
        if (this.hideLearnMore) {
          this.supportLink = '/adha/support';
          this.findADentistLink = '/adha/find-a-dentist';
        }
      });
  }

  public inviteAFriend() {
    const modalRef: NgbModalRef = this.ngbModal.open(InviteAFriendComponent);
    modalRef.result.then(() => {
      this.closeModal();
    });
  }

  public closeModal() {
    this.ngbModal.dismissAll();
  }

  public onCall() {
    this._googleAnalyticsService.sendKeyEvent('click_to_call', {
      timestamp: new Date().toISOString()
    });
  }

  public memberLogin() {
    this._googleAnalyticsService.sendKeyEvent('Click_member_login', {
      timestamp: new Date().toISOString()
    });
  }

  public findDentist() {
    this._googleAnalyticsService.sendKeyEvent('find_dentist', {
      timestamp: new Date().toISOString()
    });
  }
}
